export const startSession = async (clientUid, macAdress, actionType) => {
  const url = process.env.REACT_APP_SIMPLY_KIOSK_URL;

  // console.log("sess url", url);

  // console.log("data", { clientUid, macAdress, actionType });

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        action: actionType,
        userUid: clientUid,
        macAdress,
      }),
    });

    console.log("server response", response);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Erreur lors de l'envoi de la requête POST:", error);
  }
};
